import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Strings } from "../../shared/tools/Strings";
import { LoginStatus } from "../LoginStatus";
import { Router } from "@angular/router";
import { Any } from "typed-any-access";

@Injectable({
  providedIn: "root"
})
export class AuthService {

  public loginStatus: LoginStatus;
  public message: string | null;

  public locked: boolean;

  private waitDate: Date | null;
  private waitTimer: number;

  constructor(
    private readonly httpClient: HttpClient,
  ) {
    this.loginStatus = LoginStatus.evaluating;
    this.locked = false;
    this.waitDate = null;

    this.waitTimer = setInterval(() => {
      this.updateWaitMessage();
    }, 1000);
  }

  public async evaluateLoginStatus(): Promise<void> {
    try {
      this.loginStatus = LoginStatus.evaluating;
      const result = await this.httpClient.get(
        "/api/status/auth",
      ).toPromise();
      this.loginStatus = LoginStatus.loggedIn;
    } catch (e) {
      this.loginStatus = LoginStatus.loggedOut;
    }
  }

  public async login(pin: string): Promise<void> {
    try {
      this.loginStatus = LoginStatus.evaluating;
      this.message = null;

      const result = await this.httpClient.post(
        "/api/auth/login",
        {
          pin: pin,
        }).toPromise();
      this.loginStatus = LoginStatus.loggedIn;
    } catch (e) {
      if (e instanceof HttpErrorResponse) {
        this.loginStatus = LoginStatus.loggedOut;
        if (e.status === 401) {
          const body = new Any(e.error);
          const wait = body.get("wait").stringOrNull();
          if (wait) {
            const date = new Date(wait);
            this.waitDate = date;
            this.updateWaitMessage();
          } else {
            this.message = Strings.wrongPin;
          }
        } else {
          this.message = e.message;
        }
      } else if (e instanceof Error) {
        this.loginStatus = LoginStatus.loggedOut;
        this.message = e.message;
      } else {
        this.loginStatus = LoginStatus.loggedOut;
        this.message = Strings.unknownError;
      }
    }
  }

  public async logout(): Promise<string | null> {
    try {
      this.loginStatus = LoginStatus.evaluating;
      const result = await this.httpClient.post(
        "/api/auth/logout",
        null,
      ).toPromise();
      this.loginStatus = LoginStatus.loggedOut;
      location.reload();
      return null;
    } catch (e) {
      if (e instanceof HttpErrorResponse) {
        this.loginStatus = LoginStatus.loggedOut;
        return e.message;
      } else if (e instanceof Error) {
        this.loginStatus = LoginStatus.loggedOut;
        return e.message;
      } else {
        this.loginStatus = LoginStatus.loggedOut;
        return Strings.unknownError;
      }
    }
  }

  public isLoggedIn(): boolean {
    return this.loginStatus === LoginStatus.loggedIn;
  }

  public isLoggedOut(): boolean {
    return this.loginStatus === LoginStatus.loggedOut;
  }

  public isEvaluating(): boolean {
    return this.loginStatus === LoginStatus.evaluating;
  }

  private updateWaitMessage(): void {
    if (this.waitDate == null) {
      return;
    }
    const now = new Date();
    const delta = this.waitDate.getTime() - now.getTime();
    if (delta < 0) {
      this.waitDate = null;
      this.message = null;
      this.locked = false;
    } else {
      this.locked = true;
      const display = Math.round(delta / 1000).toString();
      this.message = `Der PIN wurde 3 mal falsch eingegeben. Der Zugang ist für ${display} Sekunden gesperrt.`;
    }
  }
}
